import Button from './Button'

export interface SortSpinnerProps {
  /** Kaydı bir üst sıraya taşı. */
  onUp: () => void
  /** Kaydı bir alt sıraya taşı. */
  onDown: () => void
  /** İlk satır → yukarı pasif. */
  disableUp?: boolean
  /** Son satır → aşağı pasif. */
  disableDown?: boolean
  /**
   * Ok yerleşimi (varsayılan `horizontal`, Figma node 903-7 — yan yana ↑/↓).
   * Yer kısıtı olan ekranlarda (ör. Yetkinlik) `vertical` ile dikey istiflenir.
   */
  orientation?: 'horizontal' | 'vertical'
  /** Yeniden sıralama sürerken tüm okları kilitle (çift tık/yarış önlenir). */
  busy?: boolean
  labelUp?: string
  labelDown?: string
}

/**
 * SORT_INDEX taşıyan yönetim tablolarında satırı yukarı/aşağı taşımak için ortak ok bileşeni. Sıra değeri
 * (numarası) gösterilmez — yalnızca oklar. Tıklama anında kalıcı olur (ayrı Kaydet yok); persist, ekrandaki
 * sırayı 1..N olarak yeniden yazar (pairwise takas değil). Tek paylaşılan bileşen; ekrana göre `orientation`
 * ile yön ayarlanır (Reuse Mandate). (Paylaşılan Button sarmalayıcısını kullanır.)
 */
export default function SortSpinner({
  onUp,
  onDown,
  disableUp,
  disableDown,
  orientation = 'horizontal',
  busy,
  labelUp,
  labelDown,
}: Readonly<SortSpinnerProps>) {
  return (
    <div
      className="sort-spinner"
      style={{
        display: 'inline-flex',
        flexDirection: orientation === 'vertical' ? 'column' : 'row',
        alignItems: 'center',
        gap: 0,
      }}
    >
      <Button
        icon="pi pi-chevron-up"
        rounded
        text
        aria-label={labelUp}
        tooltip={labelUp}
        tooltipOptions={{ position: 'bottom' }}
        disabled={busy || disableUp}
        onClick={onUp}
      />
      <Button
        icon="pi pi-chevron-down"
        rounded
        text
        style={orientation === 'vertical' ? { marginTop: '-0.5rem' } : { marginLeft: '-0.5rem' }}
        aria-label={labelDown}
        tooltip={labelDown}
        tooltipOptions={{ position: 'bottom' }}
        disabled={busy || disableDown}
        onClick={onDown}
      />
    </div>
  )
}
